import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IEarlyEnrollmentState } from "../interfaces/iearly-enrollment-status";

export const selectEarlyEnrollmentState = createFeatureSelector<IEarlyEnrollmentState>('earlyEnrollment');

export const getState = createSelector(selectEarlyEnrollmentState, (state: IEarlyEnrollmentState) => state);

